import { render } from "./UploadFile.vue?vue&type=template&id=06c47f7f&scoped=true"
import script from "./UploadFile.vue?vue&type=script&lang=js"
export * from "./UploadFile.vue?vue&type=script&lang=js"

import "./UploadFile.vue?vue&type=style&index=0&id=06c47f7f&lang=scss&scoped=true"

import exportComponent from "D:\\Source\\mobaxe\\mobaxe.docs.app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c47f7f"]])

export default __exports__